import React from 'react';

import classNames from 'classnames';
import { LinearProgress, LinearProgressProps } from '@mui/material';

import classes from './LbLinearProgress.module.scss';

type CustomColor = 'neutral';
type ProgressColor = NonNullable<LinearProgressProps['color']> | CustomColor;
type ProgressSize = 'small' | 'medium';

// Colors not in the MUI palette — extended via CustomColor type, MUI receives 'inherit'
const customColorClassMap: Partial<Record<ProgressColor, string>> = {
  neutral: classes.colorNeutral,
};

type LbLinearProgressProps = {
  value: number;
  color?: ProgressColor;
  size?: ProgressSize;
  className?: string;
};

const LbLinearProgress = ({
  value,
  color = 'primary',
  size = 'medium',
  className,
}: LbLinearProgressProps) => {
  const customColorClass = color && customColorClassMap[color];

  const progressClasses = classNames(
    classes.linearProgress,
    classes[size],
    customColorClass,
    className,
  );

  const muiColor = customColorClass ? 'inherit' : (color as LinearProgressProps['color']);

  return (
    <LinearProgress
      variant="determinate"
      value={value > 100 ? 100 : value}
      color={muiColor}
      className={progressClasses}
    />
  );
};

export { LbLinearProgress, LbLinearProgressProps };
